import { Search, Bell } from "lucide-react";
import { Link } from "react-router-dom";
import { NavLink } from "@/components/NavLink";
import { WalletButton } from "@/components/WalletButton";
import { cn } from "@/lib/utils";

export function AppNavbar() {
  return (
    <header className="border-b border-border/50 bg-card/50 backdrop-blur-xl sticky top-0 z-50">
      <div className="container px-3 sm:px-6 py-2">
        <div className="flex items-center justify-between gap-3 min-h-12 min-w-0">
          <div className="flex items-center gap-4 sm:gap-8 min-w-0">
            <Link to="/" className="flex items-center h-12 pr-2 group">
              <img 
                src="/sharpex-logotype-2.png" 
                alt="Sharpexio" 
                className="h-9 md:h-10 w-auto max-h-full object-contain transition-transform duration-300 group-hover:scale-[1.02]"
              />
            </Link>

            <nav className="flex items-center gap-1 flex-wrap min-w-0">
              <NavLink
                to="/app"
                end
                className={cn(
                  "px-3 py-1.5 rounded-md text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all duration-200"
                )}
                activeClassName="text-foreground bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/20"
              >
                Dashboard
              </NavLink>
              <NavLink
                to="/app/perps/performance"
                className={cn(
                  "px-3 py-1.5 rounded-md text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all duration-200"
                )}
                activeClassName="text-foreground bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/20"
              >
                Perps
              </NavLink>
              <NavLink
                to="/app/spot/performance"
                className={cn(
                  "px-3 py-1.5 rounded-md text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all duration-200"
                )}
                activeClassName="text-foreground bg-gradient-to-r from-primary/10 to-primary/5 border border-primary/20"
              >
                Spot
              </NavLink>
            </nav>
          </div>

          <div className="flex items-center gap-2 sm:gap-3 shrink-0">
            <button className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all duration-200">
              <Search className="w-4 h-4" />
            </button>
            <button className="p-2 rounded-lg text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-all duration-200 relative">
              <Bell className="w-4 h-4" />
              <span className="absolute top-1.5 right-1.5 w-2 h-2 bg-primary rounded-full"></span>
            </button>
            <WalletButton size="sm" showDashboardLink={false} />
          </div>
        </div>
      </div>
    </header>
  );
}
